/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-22.
 */
export const GLOBAL_NOTIFY = 'global_notify_action';



// WEBPACK FOOTER //
// ./global.types.js